import { createSelector } from "reselect";

const selectAll = (state) => state.users;

export const selectUsers = createSelector([selectAll], (users) => users.users);

export const selectAllUsers = createSelector(
  [selectAll],
  (users) => users.allUsers
);

export const selectIsFetchingUsers = createSelector(
  [selectAll],
  (users) => users.isFetchingUsers
);

export const selectIsFetchingAllUsers = createSelector(
  [selectAll],
  (users) => users.isFetchingAllUsers
);

export const selectAdminTab = createSelector(
  [selectAll],
  (users) => users.selectedTabAdmin
);

export const selectSearchQueryUsers = createSelector(
  [selectAll],
  (users) => users.searchQueryUsers
);

export const selectNumUsers = createSelector(
  [selectAll],
  (users) => users.numUsers
);

export const selectSelectedUsers = createSelector(
  [selectAll],
  (users) => users.selectedUsers
);
